import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cf5c006"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "authContainer",
  class: "auth-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "회원님의 정보보호를 위한 확인 절차입니다."),
  /*#__PURE__*/_createElementVNode("p", null, "비밀번호를 입력해주세요.")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], {
        title: "보안 비밀번호 입력",
        shouldShowUnderline: false
      }),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode($setup["PasswordInput"], {
          class: "input-field",
          label: "비밀번호",
          placeholder: "비밀번호를 입력하세요",
          name: "currentPassword",
          required: false,
          value: $setup.password,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event))
        }, null, 8 /* PROPS */, ["value"]),
        _createVNode($setup["BaseButton"], {
          class: "base-button",
          title: "확인",
          disabled: !$setup.password.length,
          onOnClick: $setup.requestAuth
        }, null, 8 /* PROPS */, ["disabled"])
      ], 512 /* NEED_PATCH */),
      ($setup.authContainer)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.authContainer
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}